<template>
  <div>

    <div class="flex justify-between">
      <material-label class="mt-6 mr-4 w-2/3" :name="$t('addressForm.street')" :value="address.street_name" />
      <material-label class="mt-6 w-1/4" :name="$t('addressForm.number')" :value="address.street_number" />
    </div>

    <div class="flex justify-between">
      <material-label class="mt-6 mr-4 w-full" :name="$t('addressForm.postcode')" :value="address.postcode" />
      <material-label class="mt-6 w-full" :name="$t('addressForm.city')" :value="address.city" />
    </div>

    <div class="flex justify-between">
      <material-label class="mt-6 mr-4 w-full" :name="$t('addressForm.state')" :value="address.state" />
      <material-label class="mt-6 w-full" :name="$t('addressForm.country')" :value="address.country" />
    </div>

    <div class="flex justify-between">
      <material-label class="mt-6 w-full" :name="$t('addressForm.phone')" :value="address.phone" />
      <div class="w-full" />
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MaterialLabel from '@/components/blocks/MaterialLabel.vue';

export default {
  props: ['address'],

  components: {
    MaterialLabel,
  },

  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      customer: 'auth/customer',
    }),
  },

};
</script>
